import ForestryLink from './forestryLink'

export default ForestryLink